const scrollToTop = () => window.scrollTo(0, 0);

const locationReload = () => window.location.reload();

const addEventListener = (evt: any, handler: (this: Window, ev: any) => any) =>
  window.addEventListener(evt, handler);

const removeEventListener = (
  evt: any,
  handler: (this: Window, ev: any) => any
) => window.removeEventListener(evt, handler);

export default {
  scrollToTop,
  locationReload,
  addEventListener,
  removeEventListener
};
